module.exports = __webpack_public_path__ + "static/media/upcoming_event_right_icon.e4af3bcb.svg";